export const HIERARCHY_LEVELS_LOCAL_STORAGE_KEY = 'hierarchy_levels';
